<script>
export default {
  props: {
    project: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },

  methods: {
    onClickCommunity() {
      if (!this.project) return
      const communityId = this.project.communityId
      const companyId = this.project.companyId
      this.$router.push({
        path: `/company/${companyId}/project?communityId=${communityId}`
      })
    }
  }
}
</script>
<template>
  <header class="project_header">
    <!-- 工地图片 -->
    <div class="project_img">
      <img :src="project.projectImgOssUrl" :alt="project.projectName" />
    </div>
    <!-- 工地属性 -->
    <div class="project_prop">
      <div class="project_prop_top line_after_1px">
        <h1 class="project_name">{{ project.projectName }}</h1>
        <div class="project_tags">
          <el-tag v-if="project.videoNum > 0" type="danger" size="mini"
            >视频</el-tag
          >
          <el-tag v-if="project.vrFlag" size="mini">VR全景</el-tag>
        </div>
      </div>
      <div class="project_prop_bottom">
        <div class="project_statistic">
          <div>
            <div>{{ project.projectManagerNum }}</div>
            <span>服务团队</span>
          </div>
          <div>
            <div>{{ project.eventNum }}</div>
            <span>装修动态</span>
          </div>
          <div>
            <div>{{ project.followsNum }}</div>
            <span>围观粉丝</span>
          </div>
        </div>
        <!-- 工地描述信息 -->
        <div class="project_desc">
          <div>
            <span class="project_desc_prefix">房屋房型</span>
            <span>{{ project.houseType ? project.houseType : '暂无' }}</span>
          </div>
          <div>
            <span class="project_desc_prefix">装修风格</span>
            <span>
              {{ project.decorationStyle ? project.decorationStyle : '暂无' }}
            </span>
          </div>
          <div>
            <span class="project_desc_prefix">建筑面积</span>
            <span>
              {{
                project.decorationArea ? project.decorationArea + '㎡' : '暂无'
              }}
            </span>
          </div>
          <div>
            <span class="project_desc_prefix">装修预算</span>
            <span>
              {{
                project.decorationBudget
                  ? project.decorationBudget + '万'
                  : '暂无'
              }}
            </span>
          </div>
          <div @click="onClickCommunity" class="project_desc_commu">
            <span class="project_desc_prefix">小区名称</span>
            <span>
              {{ project.regionName ? project.regionName : '暂无'
              }}<i class="el-icon-arrow-right"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<style lang="scss">
.project_header {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  //project图片
  .project_img {
    height: 100%;
    flex-basis: 60%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  // project属性
  .project_prop {
    flex-basis: 40%;
    padding-left: 50px;
    //上半部
    .project_prop_top {
      // height: 112px;
      padding-bottom: 30px;
      .project_name {
        font-size: 24px;
        font-weight: 600;
        color: rgba(68, 68, 68, 1);
        line-height: 30px;
      }
      .project_tags {
        margin-top: 6px;
      }
    }
    //下半部
    .project_prop_bottom {
      > div {
        margin-top: 30px;
      }

      //统计数据
      .project_statistic {
        height: 84px;
        background: rgba(250, 250, 250, 1);
        border-radius: 4px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        > div {
          div {
            text-align: center;
            height: 20px;
            font-size: 20px;
            font-weight: 600;
            color: rgba(68, 68, 68, 1);
            line-height: 20px;
            margin-bottom: 10px;
          }
          span {
            width: 56px;
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(127, 131, 137, 1);
            line-height: 14px;
          }
        }
      }
      .project_desc {
        display: flex;
        flex-wrap: wrap;
        > div {
          margin-bottom: 25px;
          flex-basis: 50%;
          .project_desc_prefix {
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(155, 155, 155, 1);
            line-height: 14px;
            margin-right: 20px;
            span {
              height: 14px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(68, 68, 68, 1);
              line-height: 14px;
            }
          }
        }

        .project_desc_commu {
          flex-basis: 100%;
          cursor: pointer;
          .el-icon-arrow-right {
            margin-left: 2px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 940px) {
  .project_header {
    .project_img {
      flex-basis: 100%;
      height: 35%;
      margin-bottom: 15px;
    }
    .project_prop {
      flex-basis: 100%;
      padding: 0 15px;
      .project_prop_top {
        padding-bottom: 20px;
      }
      .project_prop_bottom {
        > div {
          margin-top: 20px;
        }
        .project_desc {
          .project_desc_commu {
            flex-basis: 100%;
            cursor: pointer;
            .el-icon-arrow-right {
              margin-left: 2px;
            }
          } //小区名较长,在手机上50%可能会换行
        }
      }
    }
  }
}
</style>
